export { default as Icon } from '~/src/components/generic/PhosphorIcons/Icon'
export type {
  IconName,
  IconProps,
  IconPropsType,
  IconWeightType,
} from '~/src/components/generic/PhosphorIcons/types'
